module.exports = {
  message: {
      home_pro_title: 'Product Authentication',
      home_verify_title: '产品验证：',
      home_button_scan: '扫描',
      home_button_file: '选择图片',
      home_qr_text: '防伪码在哪儿？',
      home_find_title: 'Find the "Code A" on product\'s package, as per the photo as follows.',
      home_use_title: 'Use your phone\'s camera to scan the Code A or choose Code A photo in your album',
      home_fake_title: '防伪码验证操作教程：',
      home_modal_hint: '为了更方便绑定您的设备，请允许我们获取您的摄像头使用权限',
      home_modal_OK: 'OK',
      A_activate_hint: 'Product:',
      A_activate_cur: 'The current state of the product',
      A_activate_act: 'Activated',
      A_activate_act_hint: 'Activation ',
      A_activate_purchase: 'If it is not activated by you, please do not purchase.',
      A_activate_report: 'Report inferior merchants',
      A_activate_device: 'device ',
      A_activate_email: 'email address ',
      A_fake_counterfeits: 'Report counterfeits',
      A_nonactivate_prohint: '产品名称:',
      A_nonactivate_SNhint: 'SN:',
      A_nonactivate_cur: 'The current state of the product',
      A_nonactivate_act: 'Not activated',
      A_nonactivate_time: 'The product Code A has been scanned {count} times.',
      A_nonactivate_time_1: 'times',
      A_nonactivate_btn: 'Activate the product',
      A_nonactivate_scan: 'Scan Code B',
      B_bind_prohint: 'The product is authentic.',
      B_bind_email: 'Please enter your email address to bind the product',
      B_bind_addr: 'Please use a real email address to make sure this product is owned by yourself.',
      B_bind_btn: 'Bind the product',
      B_fake_fail: 'Scan failed!',
      B_fake_scan: 'Please scan the Code B',
      B_fake_btn_scan: 'Rescan the Code B',
      inform_input_name: '姓名（必需）',
      inform_input_email: '邮箱（必需）',
      inform_input_number: '电话号码（必需）',
      inform_input_feedback: 'Feedback content(Required)',
      inform_input_submit: '提交',
      A_query_result: '查询结果',
      success: 'Success',
      success_content: {
          'bind': '绑定成功',
          'activate': '激活成功'
      },
      error: 'Failed'
  }
}
